import React from 'react';
import { connect } from 'react-redux';
import withSideEffect from 'react-side-effect';
import { updateDeepLink } from 'depop/state/overlays';
import { createLink } from 'depop/utils/deeplinks';

class Noop extends React.Component {
  render() {
    return null;
  }
}

function reducePropsToState(propsList) {
  const innermostProps = propsList[propsList.length - 1];

  if (innermostProps) {
    return innermostProps;
  }
  return {};
}

function handleStateChangeOnClient(props) {
  const { update, ...config } = props;

  if (!update) {
    return;
  }

  if (Object.keys(config).length <= 0) {
    update(null);
    return;
  }

  const { path, referer, canonicalUrl, position} = config;
  const pathNotSet = (path === null || path === undefined);
  const urlNotSet = (canonicalUrl === null || canonicalUrl === undefined);

  if (pathNotSet || urlNotSet) {
    update(null);
    return false;
  }

  createLink(path, referer, {
    '$canonical_url': canonicalUrl,
  }, (link) => {
    update({
      path,
      referer,
      canonicalUrl,
      link,
    });
  });
}

const Wrapped = withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient
)(Noop);

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  update: (value, position) => dispatch(updateDeepLink(value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Wrapped);



// WEBPACK FOOTER //
// ../src/client/components/deeplinks/DeeplinkConfig.js